import {
  Component, Input, OnChanges, SimpleChanges
} from "@angular/core";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";

@Component({
  selector: "app-skeleton-loading",
  standalone: true,
  imports: [NgxSkeletonLoaderModule],
  templateUrl: "./skeleton-loading.component.html",
  styleUrls: ["./skeleton-loading.component.scss"],
})
export class SkeletonLoadingComponent implements OnChanges {
  @Input() variation: number = 1;
  @Input() colQuantity: number = 2;
  cols: number[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["colQuantity"]) {
      this.cols = new Array(this.colQuantity);
    }
  }
}
